import { JSONSchemaType } from "ajv";
import { watch, reactive, toRefs } from "vue";
import { useToast } from "vue-toastification";
import { defineStore } from "pinia";
import { delayedCall } from "@/utils";
import { LocalStorage } from "@/localStorage";

interface Settings {
  timeout_sec: number;
}

const SCHEMA: JSONSchemaType<Settings> = {
  type: "object",
  properties: {
    timeout_sec: { type: "integer" },
  },
  required: [],
};

const noop = (v: Settings) => v;
const STORAGE = new LocalStorage("toast", SCHEMA, noop, noop);

export const useToastStore = defineStore("toast", () => {
  const toast = useToast();

  const loaded = STORAGE.get() ?? ({} as Settings);

  const settings = reactive({
    timeout_sec: loaded.timeout_sec ?? 6,
  });

  // Save to localStorage after settings are modified by the user
  const save = delayedCall(500, () => STORAGE.set({ ...settings }));
  watch(settings, () => {
    toast.updateDefaults({
      timeout: settings.timeout_sec == 0 ? false : settings.timeout_sec * 1000,
    });
    save();
  });

  return {
    ...toRefs(settings),
  };
});
